interface CustomButtonProps {
  label?: string;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
}

export function CustomButton({
  label,
  onClick,
  className = "",
  disabled = false,
}: CustomButtonProps) {
  const handleClick = () => {
    if (!disabled && onClick) {
      onClick();
    }
  };

  return (
    <button
      className={`fm-button ${className}`}
      disabled={disabled}
      onClick={handleClick}
    >
      {label}
    </button>
  );
}
